import { useEffect } from 'react';
import { get } from 'lodash';
import { customCbRubricsConfSetter } from '../utils/helpers';

export default function ({
  scoringRubricResponseAnalysis,
  assignment,
  progressPerStudent,
}) {
  useEffect(() => {
    // in the situation when we have student scoring AND only scored by teacher
    // we should treat this assignment as student scoring Enabled and show custom checkbox labels on results
    const scoringScenario =
      get(assignment, 'studentScoring') || get(assignment, 'hasStudentScores');

    if (!scoringRubricResponseAnalysis && scoringScenario) {
      return customCbRubricsConfSetter({ assignment, progressPerStudent });
    }

    // if we have score students FF ON, but current assignment does not have student score for teach show
    // "Your score" as well.
    if (!scoringScenario) {
      return customCbRubricsConfSetter({
        assignment,
        mainLabel: 'Your Score',
        progressPerStudent,
      });
    }
  }, [assignment, progressPerStudent, scoringRubricResponseAnalysis]);

  useEffect(() => {
    return () => (window.customCbRubricsConf = null);
  }, []);
}
